"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoDeclareableAttributeNonSkippable = exports.videoDeclareableAttributeSkippable = void 0;
const videoDeclareableAttributeSkippable = {
    id: 3,
    name: 'InstreamVastVideoType: Skippable Instream Video',
};
exports.videoDeclareableAttributeSkippable = videoDeclareableAttributeSkippable;
const videoDeclareableAttributeNonSkippable = {
    id: 2,
    name: 'InstreamVastVideoType: Non Skippable Instream Video',
};
exports.videoDeclareableAttributeNonSkippable = videoDeclareableAttributeNonSkippable;
//# sourceMappingURL=VideoDeclarableAttributes.js.map